"use client";

import { GeistProvider } from "@geist-ui/core";

//Work around to get GeistProvider to load as client
export default GeistProvider;
